module.exports = __webpack_public_path__ + "fonts/BourgeoisRounded-BoldCondensed.db46a8dd.ttf";